import { ItemValue, Serializer, SurveyModel, Question } from "survey-core";

// Register a boolean property to enable auto-select of single visible choice
const AUTO_SELECT_PROPERTY = "auto_select_single_choice";

let propertyRegistered = false;
export const registerDropdownCustomizations = () => {
  if (propertyRegistered) {
    return;
  }
  Serializer.addProperty("dropdown", {
    name: `${AUTO_SELECT_PROPERTY}:boolean`,
    category: "general",
    visible: true,
    default: false,
    displayName: "Auto select when only one visible choice",
  });
  propertyRegistered = true;
};

export const applyDropdownCustomizations = (model: SurveyModel) => {
  registerDropdownCustomizations();

  // To avoid re-binding events if called multiple times.
  const FLAG: unique symbol = Symbol("autoSelectSingleChoiceBound");
  // Extend model at runtime with a symbol property without using 'any'
  const modelWithFlag = model as SurveyModel & { [FLAG]?: boolean };
  if (modelWithFlag[FLAG]) {
    return;
  }
  modelWithFlag[FLAG] = true;

  const tryAutoSelect = (q: Question) => {
    if (q.getType() !== "dropdown") return;
    const dropdown = q as Question & { [AUTO_SELECT_PROPERTY]?: boolean };
    if (!dropdown[AUTO_SELECT_PROPERTY]) return;
    const hasValue =
      dropdown.value !== undefined &&
      dropdown.value !== null &&
      dropdown.value !== "";
    if (hasValue) return;
    const visibleChoices =
      (dropdown as unknown as { visibleChoices?: ItemValue[] })
        .visibleChoices ?? [];
    if (visibleChoices.length === 1) {
      dropdown.value = visibleChoices[0].value;
    }
  };

  // Initial pass
  model.getAllQuestions().forEach((q) => tryAutoSelect(q));

  // Re-run when value choices are loaded/filtered or visibility changes.
  model.onAfterRenderQuestion.add((_, opt) => {
    tryAutoSelect(opt.question as Question);
  });
  model.onVisibleChanged.add((_, opt) => {
    if (opt.visible) {
      tryAutoSelect(opt.question as Question);
    }
  });
};
